/**
 * core · documentação in-app (spec 03 §2 · tela 2.4 · CONCEITO §20.5).
 *
 * A documentação **não tem tabela**: o conteúdo é versionado no repositório, ao lado
 * do código, e `GET /docs/capitulos` o serve. A consequência é a que a spec quer —
 * mudar um comportamento e o capítulo que o explica acontece no mesmo commit, e não
 * existe manual defasado esperando alguém lembrar.
 */
import { z } from 'zod'

export const AREAS = ['Fundamentos', 'Comercial', 'Receita', 'Financeiro', 'Operações'] as const
export const area = z.enum(AREAS)
export type Area = z.infer<typeof area>

export const capitulo = z.object({
  id: z.string(),
  titulo: z.string(),
  area,
  atualizadoEm: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  minutosLeitura: z.number().int().positive(),
  /** HTML já estruturado (h3/p) — o corpo vive no repositório, não em banco. */
  corpo: z.string(),
})
export type Capitulo = z.infer<typeof capitulo>

export const respostaDeCapitulos = z.object({ capitulos: z.array(capitulo) })
export type RespostaDeCapitulos = z.infer<typeof respostaDeCapitulos>
